<template>
    <div class="list-icon">
        <h3 class="color_Azul family-01" v-if="(form.TipoTema == 'TEXTO')" >{{form.Titulo}}</h3> 
        <hr v-show="(form.TipoTema == 'TEXTO' && form.Titulo !='')" class="divider-02 hr-sm-left-0 bg-color"> 
        <h5 v-show="(form.TipoTema == 'TEXTO' && form.Subtitulo !='')" class="color_Azul">{{form.Subtitulo}}</h5>
        <div class="form-group row" v-if="(form.TipoTema == 'TEXTO')">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                <div v-for="(detalle,key3) in form.detContenidoTema" :key="key3" v-html="detalle.Descripcion"></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:['value','RutaFile','listIconos','index'],
    data() {
        return {
            form:this.value
        }
    },methods: {
        iconoFiltrado(buscar)
        {
            let aBuscar = buscar;
            let devuelve = '';
            let arr = this.listIconos.filter(function(vl){
                if(aBuscar!=''){
                    if(aBuscar == vl.Id){
                        return vl;
                    }
                    else{
                        return '';
                    }
                }
            });

            if(arr[0]){
                devuelve = arr[0].Icono;
            }
            
            return devuelve;
        },
    },
}
</script>